import { flatten } from 'lodash';
import { ColumnsType } from 'antd/lib/table';

import { getColumnFilteredValue } from '../../components/table/columnFormatHelpers';
import { ProgramUtilityList } from '../program/programUtility';
import { INomination } from './interface';

export const getUtilityFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('utility_id', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue).map(utilityId => utilityId.toString());
    }
    return filteredValue;
};

export function buildProgramUtilityTableFilter(state: any) {
    const column: ColumnsType<INomination>[number] = {
        filterMultiple: true,
        filters: ProgramUtilityList.map(utility => ({ text: utility.name, value: utility.utility_id, key: utility.utility_id })),
        filteredValue: getUtilityFilterValue(state),
        filterSearch: (input, record) => !!record?.text?.toString()?.toLowerCase().includes(input.toLowerCase()),
    };

    return column;
}
